module.exports = __webpack_public_path__ + "static/gallery23-0124db53addcbe7ce058cfeaf6257844.jpg";